// `/execution` — the strategist board: a strategist's My Accounts, everyone else's Strategist
// Accounts (`lib/viewTabs.ts`). An AE (or somebody viewing as one) is
// sent to their own book on `/ae`, as before go-live: the board was never offered to an AE. The
// redirect keeps the query string, so a Scout reply's `/execution?account=<id>` link still opens
// the account's panel.
//
// The board renders while `/api/me` is still answering rather than waiting on it: the cheap call
// is usually cached by the landing redirect, and holding the board back for it would add a round
// trip for every strategist to save an AE one wasted book read.

import { Navigate, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchMe } from '../api/client';
import { useAuthContext } from '../auth/AuthContext';
import { ExecutionView } from './ExecutionView';

export function BoardRoute() {
  const { getToken } = useAuthContext();
  const location = useLocation();

  const meQuery = useQuery({
    queryKey: ['me'],
    queryFn: () => fetchMe(getToken),
  });

  if (meQuery.data?.viewer.role === 'ae') {
    return <Navigate to={'/ae' + location.search} replace />;
  }
  return <ExecutionView />;
}
